export default "__VITE_ASSET__01671114__"